import { Button, Space, Table, Tooltip } from "antd";
import ModalCreated from "../ModalCreated";
import { useEffect, useMemo, useState } from "react";
import ModalDelete from "../ModalDelete";
import { roleKeys, roles } from "constants/index";
import ModalChangeStore from "../ModalChangeStore";
import ModalChangePassword from "../ModalChangePassword";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ModalTimeSheetUser from "features/admin/components/ModalTimeSheetUser";
import { rolesChangePw, rolesChangeStore, rolesDelete, rolesEdit, rolesNotChangePw, rolesNotChangeStore, rolesShowDetailTimeSheet } from "features/users/roles";
import { getUser } from "utils/index";

export default function TableList({
  loading,
  users,
  optionsRole,
  optionsStore,
  openNotificationWithIcon,
  onSearch,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [idSelected, setIdSelected] = useState(false);
  const [dataUser, setDataUser] = useState();

  const { t } = useTranslation()

  const handleDetailTimeSheet = (id) => {
    setOpenModalDetail(true);
    setIdSelected(id)
  }

  useEffect(() => {
    !openModal && setDataUser(null);
  }, [openModal]);

  // const getShopByRole = async () => {
  //   try {
  //     const res = await shopApi.getShopByRole();
  //     if (res.success) {
  //       setListShop(
  //         res.shops
  //           .map(
  //             (shop) =>
  //               shop.shopId && {
  //                 value: shop.shopId,
  //                 label: shop.shopName,
  //               }
  //           )
  //           .filter((shop) => shop)
  //       );
  //     }
  //   } catch (error) {
  //     openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
  //   }
  // };

  // useEffect(() => {
  //   (user.role == roles.admin ||
  //     user.role == roles.departmentManager ||
  //     user.role == roles.areaManager) &&
  //     getShopByRole();
  // }, [user.role]);

  const columns = useMemo(() => [
    {
      title: t('employeeCode'),
      dataIndex: "employee_code",
      key: "employee_code",
    },
    {
      title: t('fullName'),
      dataIndex: "name",
      key: "name",
      render: (_, record) => rolesShowDetailTimeSheet.includes(+record.role) ? <a onClick={() => handleDetailTimeSheet(record._id)}>{_}</a> : _
    },
    {
      title: t('position'),
      dataIndex: "role",
      key: "role",
      render: (role) => t(roleKeys[role]),
    },
    {
      title: t('shop'),
      dataIndex: "shops",
      key: "shops",
      render: (shops) => shops.map((el) => el.shop?.name).join(", "),
    },
    {
      title: t('userName'),
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: t('action'),
      dataIndex: "action",
      key: "action",
      render: (text, row) => {
        return (
          <Space key={row._id}>
            {rolesEdit.includes(+getUser().role) && (
              <Tooltip title={t('edit')}>
                <Button
                  title={t('edit')}
                  onClick={() => {
                    setOpenModal(true);
                    setDataUser(row);
                  }}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
            )}
            {
              rolesDelete.includes(+getUser().role) && <ModalDelete
                id={row._id}
                onSearch={onSearch}
                openNotificationWithIcon={openNotificationWithIcon}
              />
            }
            {rolesChangeStore.includes(+row.role) && !rolesNotChangeStore.includes(+getUser().role) && (
              <ModalChangeStore
                id={row._id}
                onSearch={onSearch}
                openNotificationWithIcon={openNotificationWithIcon}
                optionsStore={optionsStore}
                data={row}
              />
            )}
            {rolesChangePw.includes(+getUser().role) && !rolesNotChangePw.includes(+row.role) && (
              <ModalChangePassword
                id={row._id}
                openNotificationWithIcon={openNotificationWithIcon}
              />
            )}
          </Space>
        );
      },
    },
  ], [onSearch, openNotificationWithIcon, optionsStore, t]);

  return (
    <>
      <Table loading={loading} columns={columns} dataSource={users} bordered />
      <ModalCreated
        onSearch={onSearch}
        setOpenModal={setOpenModal}
        openModal={openModal}
        optionsRole={optionsRole}
        optionsStore={optionsStore}
        dataUser={dataUser}
        openNotificationWithIcon={openNotificationWithIcon}
      />
      <ModalTimeSheetUser
        openModal={openModalDetail}
        setOpenModal={setOpenModalDetail}
        id={idSelected}
        setId={setIdSelected}
        openNotificationWithIcon={openNotificationWithIcon}
      />
    </>
  );
}
